import Vue from "vue";
import Router from "vue-router";
import routes from "./route-files/routes";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (window.localStorage.userType && !to.meta.publicView) {
    const userType = window.atob(window.localStorage.userType);
    if (to.meta.allowedUserTypes.indexOf(userType) > -1) {
      next();
    } else {
      next("/");
    }
  } else if (to.meta.publicView) {
    next();
  } else {
    next("/login");
  }
});

export default router;
